/* eslint-disable promise/catch-or-return */
if (!customElements.get('facet-filters-form')) {
  customElements.define(
    'facet-filters-form',
    class FacetFiltersForm extends HTMLElement {
      constructor() {
        super();

        console.log('hrere');

        this.elements = {
          cache: {},
          main: false,
          facetForm: false,
          facetWrapper: false,
          priceMin: false,
          priceMax: false,
          filterMenuItems: [],
        };

        window.addEventListener('DOMContentLoaded', () => {
          this.initCache();

          this.registerEvents();

          const currentUrl = window.location.search;
          const currentSearchParams = new URLSearchParams(currentUrl);
          const sortByValue = currentSearchParams.get('sort_by');

          if (sortByValue) {
            this.hideFeaturedProducts(currentSearchParams);
          }

          this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        });

        let productObject =
          document.getElementById('CollectionJson') ||
          document.getElementById('SearchCollectionJson');

        this.valueProductCountElements = Array.from(
          document.querySelectorAll('.js-filter__value-count')
        );

        if (productObject) {
          this.collection = JSON.parse(productObject.textContent);
          this.renderNewProductCount();
          this.renderNewFacetCount(this.valueProductCountElements);
        }
      }

      initCache() {
        this.elements.main = this;

        this.elements.facetForms = this.elements.main.querySelectorAll('facet-filters-form form');
        this.elements.facetWrapper = this.elements.main.querySelector('#FacetsWrapperDesktop');
        this.elements.facetOptionsWrapper = this.elements.main.querySelector(
          '.facet-filters-form-options'
        );
        this.elements.facetOptionsDisclosures = this.elements.main.querySelectorAll(
          '.facet-filters-form-options .js-filter'
        );

        this.elements.filterMenuDetails = this.elements.main.querySelectorAll(
          '#FacetsWrapperDesktop details'
        );
        this.elements.filterMenuSummaries = this.elements.main.querySelectorAll(
          '#FacetsWrapperDesktop summary'
        );

        this.elements.facetSelectSortBy = this.elements.main.querySelectorAll(
          'select.select__select[name="sort_by"]'
        );

        this.elements.priceMin =
          this.elements.main.querySelector('.facets__price')?.dataset.priceMin;
        this.elements.priceMax =
          this.elements.main.querySelector('.facets__price')?.dataset.priceMax;

        this.elements.filterData = [];
        this.elements.searchParamsInitial = window.location.search.slice(1);
        this.elements.searchParamsPrev = window.location.search.slice(1);

        this.debouncedOnSubmit = this.debounce(event => {
          this.onSubmitHandler(event);
        }, 500);
      }

      registerEvents() {
        // Submit sort form on change
        this.elements.facetSelectSortBy.forEach(item => {
          item.addEventListener('change', () => {
            var closestFilterForm = item.closest('form');
            var closestFilterFormSubmit = closestFilterForm.querySelector('button[type="submit"]');
            closestFilterFormSubmit.click();
          });
        });

        // Toggle desktop filters container
        this.elements.filterMenuSummaries.forEach(item => {
          item.addEventListener('click', this.manageOptionContainer.bind(this));
        });

        // Forms submit
        this.elements.facetForms.forEach(form => {
          form.addEventListener('submit', this.onSubmitHandler.bind(this));
        });
        this.setListeners();
      }

      setListeners() {
        const onHistoryChange = event => {
          const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
          console.log('onHistoryChange');
          if (searchParams === this.elements.searchParamsPrev) {
            return;
          }
          this.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
      }

      manageOptionContainer(event) {
        // event.preventDefault();

        const filterIndex = event.target.dataset.index;

        // Close all Details first
        this.elements.filterMenuDetails.forEach(item => {
          if (item.dataset.index !== filterIndex) {
            item.removeAttribute('open');
          }
        });

        // Close all Options first
        this.elements.facetOptionsDisclosures.forEach(item => {
          item.classList.remove('active');
        });

        // add active class to targeted filter
        this.elements.facetOptionsWrapper
          .querySelector(`.js-filter[data-index="${filterIndex}"]`)
          .classList.add('active');

        const facetFormClass = this;
        setTimeout(() => {
          const activeItems = facetFormClass.elements.main.querySelectorAll(
            '#FacetsWrapperDesktop details[open]'
          );
          // options container state
          if (activeItems.length > 0) {
            facetFormClass.elements.facetOptionsWrapper.classList.add('isOpen');
          } else {
            facetFormClass.elements.facetOptionsWrapper.classList.remove('isOpen');
          }
        }, 200);
      }

      toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach(element => {
          element.classList.toggle('disabled', disable);
        });
      }

      renderPage(searchParams, event, updateURLHash = true) {
        this.elements.searchParamsPrev = searchParams;
        const sections = this.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');

        document
          .getElementById('ProductGridContainer')
          .querySelector('.collection')
          .classList.add('loading');
        if (countContainer) {
          countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
          countContainerDesktop.classList.add('loading');
        }

        sections.forEach(section => {
          // const url = `${window.location.pathname}?${searchParams}`;
          const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
          const filterDataUrl = element => element.url === url;

          // eslint-disable-next-line babel/no-unused-expressions
          this.elements.filterData.some(filterDataUrl)
            ? this.renderSectionFromCache(filterDataUrl, event, url)
            : this.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) {
          this.updateURLHash(searchParams);
          // dispatch custom event
          const event = new CustomEvent('filter:updated', {
            detail: {
              searchParams: searchParams,
            },
          });
          document.dispatchEvent(event);
        }
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      onKeyUpEscape(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') {
          return;
        }

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) {
          return;
        }

        openDetailsElement.removeAttribute('open');

        const summaryElement = openDetailsElement.querySelector('summary');
        summaryElement.setAttribute('aria-expanded', false);
        summaryElement.focus();
      }

      renderSectionFromFetch(url, event) {
        fetch(url)
          .then(response => response.text())
          .then(responseText => {
            const html = responseText;
            this.elements.filterData = [...this.elements.filterData, { html, url }];
            this.renderFilters(html, event);
            this.renderProductGridContainer(html);
            this.renderProductCount(html);
            // this.updateRangeInput();
            this.hideFeaturedProducts(url);
          });
      }

      renderSectionFromCache(filterDataUrl, event, url) {
        const html = this.elements.filterData.find(filterDataUrl).html;
        this.renderFilters(html, event);
        this.renderProductGridContainer(html);
        this.renderProductCount(html);

        this.hideFeaturedProducts(url);

        // this.updateRangeInput();
      }

      renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('ProductGridContainer').innerHTML;
      }

      renderProductCount(html) {
        const count = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('ProductCount').innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
          // containerDesktop.innerHTML = count;
          containerDesktop.classList.remove('loading');
        }
      }

      renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const valueProductCountElements = parsedHTML.querySelectorAll('.js-filter__value-count');

        this.renderNewFacetCount(valueProductCountElements);

        const facetDetailsElements = parsedHTML.querySelectorAll(
          '#FacetFiltersForm .facet-filters-form-options .js-filter:not(.js-price-range-filter), #FacetFiltersFormMobile .js-filter:not(.js-price-range-filter)'
        );
        const matchesIndex = element => {
          const jsFilter = event ? event.target.closest('.js-filter') : undefined;
          return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        const facetsToRender = Array.from(facetDetailsElements).filter(
          element => !matchesIndex(element)
        );
        // const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        // console.log(facetsToRender);
        facetsToRender.forEach(element => {
          
          const filtersFormOptions = document.querySelector(
            `.facet-filters-form-options .js-filter[data-index="${element.dataset.index}"]`
          );


          if (filtersFormOptions) {
            filtersFormOptions.innerHTML = element.innerHTML;
          }
        });

        this.renderActiveFacets(parsedHTML);
        this.renderAdditionalElements(parsedHTML);
        setTimeout(() => {
          this.renderNewProductCount();
        }, 0);

        // if (countsToRender) { this.renderCounts(countsToRender, event.target.closest('.js-filter')); }
      }

      renderNewFacetCount = filterElArray => {
        if (!filterElArray) {
          return;
        }

        const hiddenItems = this.collection.filter(item => item.tags.includes('hide'));

        if (hiddenItems.length === 0) {
          return;
        }

        filterElArray.forEach(el => {
          const value = el.dataset.value;
          const count = +el.dataset.count;

          hiddenItems.forEach(item => {
            if (value === item.type) {
              if (count - hiddenItems.length === 0) {
                const filterItemEl = el.closest('.js-filter__item');
                if (filterItemEl) {
                  el.closest('.js-filter__item').classList.add('hide');
                }
              }
              el.innerHTML = `(${count - hiddenItems.length})`;
            }
          });
        });
      };

      renderNewProductCount = () => {
        const productCountEl = document.querySelector('.js-product-count');
        if (!productCountEl) {
          return;
        }

        if (this.querySelector('[type="application/json"]')) {
          const filterdCollectionTags = this.collection.filter(item => !item.tags.includes('hide'));
          productCountEl.innerHTML = `${filterdCollectionTags.length} items`;
        }
      };

      renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
        
        activeFacetElementSelectors.forEach(selector => {
          const activeFacetsElement = html.querySelector(selector);

          if (!activeFacetsElement) {
            return;
          }

          document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        this.toggleActiveFacets(false);
      }

      renderAdditionalElements(html) {
        const mobileElementSelectors = [
          '.mobile-facets__open',
          '.mobile-facets__count',
          '.sorting',
        ];

        mobileElementSelectors.forEach(selector => {
          if (!html.querySelector(selector)) {
            return;
          }
          document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
      }

      renderCounts(source, target) {
        const targetElement = target.querySelector('.facets__selected');
        const sourceElement = source.querySelector('.facets__selected');

        const targetElementAccessibility = target.querySelector('.facets__summary');
        const sourceElementAccessibility = source.querySelector('.facets__summary');

        if (sourceElement && targetElement) {
          target.querySelector('.facets__selected').outerHTML =
            source.querySelector('.facets__selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
          target.querySelector('.facets__summary').outerHTML =
            source.querySelector('.facets__summary').outerHTML;
        }
      }

      updateURLHash(searchParams) {
        history.pushState(
          { searchParams },
          '',
          `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
        );
      }

      getSections() {
        const selectedElement =
          document.querySelector('.collection-product-list') ||
          document.querySelector('.product-grid-container');

        return [
          {
            section: selectedElement.dataset.id,
          },
        ];
      }

      createSearchParams(form) {
        const formData = new FormData(form);
        // console.log( formData );
        const formMin = formData.get('filter.v.price.gte');
        const formMax = formData.get('filter.v.price.lte');
        //
        if (this.elements.priceMin == formMin) {
          formData.delete('filter.v.price.gte');
        }
        if (this.elements.priceMax == formMax) {
          formData.delete('filter.v.price.lte');
        }
        //
        return new URLSearchParams(formData).toString();
      }

      onSubmitForm(searchParams, event) {
        this.renderPage(searchParams, event);

        // Close all Details first
        this.elements.filterMenuDetails.forEach(item => {
          item.removeAttribute('open');
        });

        // Close all Options first
        this.elements.facetOptionsDisclosures.forEach(item => {
          item.classList.remove('active');
        });

        // Remove isOpen class
        this.elements.facetOptionsWrapper.classList.remove('isOpen');
      }

      onSubmitHandler(event) {
        event.preventDefault();
        // const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className === 'mobile-facets__checkbox') {
          const searchParams = this.createSearchParams(event.target.closest('form'));
          this.onSubmitForm(searchParams, event);
        } else {
          let targetFormUrl = '';
          const targetForm = document.getElementById(event.target.closest('form').id);
          const isMobile = targetForm.id === 'FacetFiltersFormMobile';

          // sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (
              targetForm.id === 'FacetSortForm' ||
              targetForm.id === 'FacetFiltersForm' ||
              targetForm.id === 'FacetSortDrawerForm'
            ) {
              targetFormUrl = this.createSearchParams(targetForm);
            }
          } else if (targetForm.id === 'FacetFiltersFormMobile') {
            targetFormUrl = this.createSearchParams(targetForm);
          }
          // });
          // alert("Before submit form join");
          this.onSubmitForm(targetFormUrl, event);
        }
      }

      onActiveFilterClick(event) {
        event.preventDefault();
        this.toggleActiveFacets();
        const url =
          event.currentTarget.href.indexOf('?') == -1
            ? ''
            : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        this.renderPage(url);
      }

      hideFeaturedProducts(url) {
        const newSearchParams = new URLSearchParams(url);
        var sortByValue = newSearchParams.get('sort_by');
        const allFeaturedProducts = Array.from(document.querySelectorAll('.featured'));

        if (sortByValue.includes('best-selling') || sortByValue.includes('manual')) {
          allFeaturedProducts.forEach(product => {
            if (!product.classList.contains('grid__item--featured')) {
              product.classList.add('grid__item--featured');
              productImages.forEach(image => {
                if (image.classList.contains('product-card__thumbnail--primary')) {
                  image.classList.remove('product-card__thumbnail--primary');
                  image.classList.add('product-card__thumbnail--secondary');
                } else {
                  image.classList.remove('product-card__thumbnail--secondary');
                  image.classList.add('product-card__thumbnail--primary');
                }
              });
            }
          });
        } else {
          allFeaturedProducts.forEach(product => {
            product.classList.remove('grid__item--featured');
            const productImages = product.querySelectorAll('.product-card__thumbnail');
            productImages.forEach(image => {
              if (image.classList.contains('product-card__thumbnail--primary')) {
                image.classList.remove('product-card__thumbnail--primary');
                image.classList.add('product-card__thumbnail--secondary');
              }
              if (image.classList.contains('product-card__thumbnail--secondary')) {
                image.classList.remove('product-card__thumbnail--secondary');
                image.classList.add('product-card__thumbnail--primary');
              }
            });
          });
        }
      }
    }
  );
}

if (!customElements.get('price-range')) {
  customElements.define(
    'price-range',
    class PriceRange extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          cache: {},
          main: false,
          rangeInput: false,
          priceDisplays: false,
          progress: false,
        };

        window.addEventListener('DOMContentLoaded', () => {
          this.initCache();

          this.setMinAndMaxValues();

          this.registerEvents();
        });
      }

      initCache() {
        this.elements.main = this;
        this.elements.rangeInput = this.querySelectorAll('.range-input input');
        this.elements.priceDisplays = this.querySelectorAll('.price-display .price-display-value');
        this.elements.progress = this.querySelector('.slider .progress');

        this.elements.priceGap = 5;
      }

      registerEvents() {
        this.elements.rangeInput.forEach(input => {
          // console.log( input );
          input.addEventListener('input', this.updateRangeInput.bind(this));
        });
      }

      updateRangeInput(e) {
        // console.log(e);
        // console.log(this);

        const minVal = parseInt(this.elements.rangeInput[0].value);
        const maxVal = parseInt(this.elements.rangeInput[1].value);

        if (maxVal - minVal < this.elements.priceGap) {
          //
          console.log('Should not happen');

          if (e.target.className === 'range-min') {
            this.elements.rangeInput[0].value = maxVal - this.elements.priceGap;
          } else {
            this.elements.rangeInput[1].value = minVal + this.elements.priceGap;
          }
        } else {
          // Set range
          this.setMinAndMaxValues();
        }
      }

      // eslint-disable-next-line shopify/prefer-early-return
      setMinAndMaxValues() {
        if (this.elements.rangeInput.length > 0) {
          const minVal = parseInt(this.elements.rangeInput[0].value);
          const maxVal = parseInt(this.elements.rangeInput[1].value);

          const rangeMaxVal = parseInt(this.elements.rangeInput[1].max);

          const progressMin = minVal > 0 ? (minVal * 100) / rangeMaxVal : 0;
          const progressMax = 100 - (maxVal * 100) / rangeMaxVal;

          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
          });

          // Displays
          this.elements.priceDisplays[0].innerHTML = formatter.format(minVal);
          this.elements.priceDisplays[1].innerHTML = formatter.format(maxVal);

          // Progress
          this.elements.progress.style.left = `${progressMin}%`;
          this.elements.progress.style.right = `${progressMax}%`;
        }
      }
    }
  );
}

if (!customElements.get('facet-remove')) {
  customElements.define(
    'facet-remove',
    class FacetRemove extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          main: false,
          facetLink: false,
        };

        this.initCache();

        // this.registerEvents();
      }

      initCache() {
        this.elements.faceLink = this.querySelector('a');
        if (this.elements.faceLink) {
          this.elements.faceLink.setAttribute('role', 'button');
        }
      }

      // registerEvents() {
      //   if(this.elements.faceLink) {
      //     this.elements.faceLink.addEventListener('keyup', (event) => {
      //       event.preventDefault();
      //       if (event.code.toUpperCase() === 'SPACE') { this.closeFilter(event); }
      //     });

      //     this.elements.faceLink.addEventListener('click', this.closeFilter.bind(this));
      //   }
      // }

      // closeFilter(event) {
      //   event.preventDefault();
      //   const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      //   form.onActiveFilterClick(event);
      // }
    }
  );
}

if (!customElements.get('menu-drawer')) {
  customElements.define(
    'menu-drawer',
    class MenuDrawer extends HTMLElement {
      constructor() {
        super();

        this.trapFocusHandlers = {};

        window.addEventListener('DOMContentLoaded', () => {
          this.mainDetailsToggle = this.querySelector('details');
          this.closeMobileFilters = this.querySelector('[data-close]');

          // Close
          if (this.closeMobileFilters) {
            this.closeMobileFilters.addEventListener('click', this.onFocusOut());
          }

          if (navigator.platform === 'iPhone') {
            document.documentElement.style.setProperty(
              '--viewport-height',
              `${window.innerHeight}px`
            );
          }

          this.addEventListener('keyup', this.onKeyUp.bind(this));
          this.addEventListener('focusout', this.onFocusOut.bind(this));
          this.bindEvents();
        });
      }

      bindEvents() {
        this.querySelectorAll('summary').forEach(summary =>
          summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
        this.querySelectorAll('button').forEach(button =>
          button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') {
          return;
        }

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) {
          return;
        }

        openDetailsElement === this.mainDetailsToggle
          ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
          : this.closeSubmenu(openDetailsElement);
      }

      onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
          this.trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
          summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
          if (isOpen) {
            event.preventDefault();
          }
          isOpen
            ? this.closeMenuDrawer(event, summaryElement)
            : this.openMenuDrawer(summaryElement);
        } else {
          setTimeout(() => {
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', true);
            parentMenuElement && parentMenuElement.classList.add('submenu-open');
            !reducedMotion || reducedMotion.matches
              ? addTrapFocus()
              : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
          }, 100);
        }
      }

      openMenuDrawer(summaryElement) {
        setTimeout(() => {
          this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        this.trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
      }

      removeTrapFocus(elementToFocus = null) {
        document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
        document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);

        if (elementToFocus) {
          elementToFocus.focus();
        }
      }

      closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) {
          return;
        }

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
          submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        this.removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
      }

      onFocusOut(event) {
        setTimeout(() => {
          if (this.mainDetailsToggle) {
            if (
              this.mainDetailsToggle.hasAttribute('open') &&
              !this.mainDetailsToggle.contains(document.activeElement)
            ) {
              this.closeMenuDrawer();
            }
          }
        });
      }

      onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
      }

      closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        this.removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
      }

      closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = time => {
          if (animationStart === undefined) {
            animationStart = time;
          }

          const elapsedTime = time - animationStart;

          if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
          } else {
            detailsElement.removeAttribute('open');
            if (detailsElement.closest('details[open]')) {
              this.trapFocus(
                detailsElement.closest('details[open]'),
                detailsElement.querySelector('summary')
              );
            }
          }
        };

        window.requestAnimationFrame(handleAnimation);
      }

      getFocusableElements(container) {
        return Array.from(
          container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
          )
        );
      }

      trapFocus(container, elementToFocus = container) {
        const elements = this.getFocusableElements(container);
        const first = elements[0];
        const last = elements[elements.length - 1];

        removeTrapFocus();

        this.trapFocusHandlers.focusin = event => {
          if (event.target !== container && event.target !== last && event.target !== first) {
            return;
          }

          document.addEventListener('keydown', this.trapFocusHandlers.keydown);
        };

        this.trapFocusHandlers.focusout = function () {
          document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
        };

        this.trapFocusHandlers.keydown = function (event) {
          if (event.code.toUpperCase() !== 'TAB') {
            return;
          } // If not TAB key
          // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
          }

          //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
          }
        };

        document.addEventListener('focusout', this.trapFocusHandlers.focusout);
        document.addEventListener('focusin', this.trapFocusHandlers.focusin);

        elementToFocus.focus();
      }
    }
  );
}
